export default "__VITE_ASSET__DMCfH7Mt__"